import { Input } from '@base-ui/react/input'
import clsx from 'clsx'
import { forwardRef } from 'react'

export interface TextInputProps extends React.InputHTMLAttributes<HTMLInputElement> {}

export const TextInput = forwardRef<HTMLInputElement, TextInputProps>(
  ({ className, ...props }, ref) => {
    return (
      <Input
        ref={ref}
        className={clsx(
          'bg-sand-25 border border-gray-stroke h-10 w-full rounded-lg px-4 text-sm outline-none transition-colors',
          'focus:ring-0 focus:border-forest disabled:opacity-40 disabled:cursor-not-allowed',
          'placeholder:text-charcoal-50',
          'data-invalid:border-brick-light data-invalid:focus:border-brick-light',
          className
        )}
        {...props}
      />
    )
  }
)

TextInput.displayName = 'FormsV2.TextInput'
